module.exports = __webpack_public_path__ + "img/YCT0011.446405f8.png";